import { CONNECTORS_IDS } from "../constants/sources"
import { useCheckServiceIsConnected } from "./connected-services"

export default function useGAConnectorConnected() {
  return useCheckServiceIsConnected(CONNECTORS_IDS.GOOGLE_ANALYTICS_4)
}
